import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";

interface CloseFulfilmentRequest {
    levyId: string;
    taxPayerWorkspaceId: string;
    year: number;
}

export function useCloseFulfilment() {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders({ method: "POST" });
    const queryClient = useQueryClient();

    const mutation = useMutation<boolean, Error, CloseFulfilmentRequest>({
        mutationFn: async (request) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/fulfilments/${request.levyId}/years/${request.year}/tax-payers/${request.taxPayerWorkspaceId}/activities/close`,
                {
                    headers,
                    method: "POST",
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return true;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetFulfilmentActivities"],
            });
            queryClient.invalidateQueries({
                queryKey: ["useGetFulfilmentDetail"],
            });
            queryClient.invalidateQueries({ queryKey: ["useGetFulfilments"] });
            queryClient.invalidateQueries({ queryKey: ["useGetKPIs"] });
        },
        meta: {
            errorMessage: t("errors.messages.closeFulfilment"),
        },
    });

    return mutation;
}
